import axios from '../../axios/index.js'

export default {
    getToken(data){
        return axios.get('/precisoft/getToken')
    },
}
